import type { ReactNode } from 'react';
import { IconButton } from '../Button/IconButton';
import { Box, Flex, HStack, type BoxProps } from '../Core';
import { FormControlSizes } from '../Form/types';
import { Icon, IconName } from '../Icons';

export interface FlexDrawerHeaderProps extends Omit<BoxProps, 'title'> {
  title?: ReactNode;
  icon?: IconName;
  actions?: ReactNode;
  onClose: () => void;
  closeButtonTestId?: string;
}

export function FlexDrawerHeader({
  title,
  icon,
  actions,
  onClose,
  closeButtonTestId = 'drawer-close-button',
  ...boxProps
}: FlexDrawerHeaderProps) {
  return (
    <Box
      p="spacing12"
      color="colors.gray.100"
      borderBottom="1px solid"
      borderColor="backgroundBody"
      background="backgroundDrawer"
      {...boxProps}
    >
      <Flex justifyContent="space-between" alignItems="center" gap="spacing8">
        <Box minWidth={0} flex="1 1 auto" overflowX="hidden">
          {icon != null ? (
            <Flex alignItems="center" gap="spacing8">
              <Icon icon={icon} color="colorTextDefault" />
              {title}
            </Flex>
          ) : (
            title
          )}
        </Box>

        <HStack gap="spacing8" flex="0 0 auto">
          {actions}
          <IconButton
            type="button"
            icon={IconName.Close}
            size={FormControlSizes.Small}
            ghost
            aria-label="Close drawer"
            onClick={onClose}
            data-testid={closeButtonTestId}
          />
        </HStack>
      </Flex>
    </Box>
  );
}
